import { registerComponent, scrollLock, triggerEvent } from "helpers";

function replaceElementTag(element, tagName) {
  const replacement = document.createElement(tagName);

  for (const attribute of [...element.attributes]) {
    replacement.setAttribute(attribute.name, attribute.value);
  }

  replacement.append(...element.childNodes);
  element.replaceWith(replacement);
}

registerComponent(
  "wyatt-drawer",
  class WyattDrawer extends HTMLElement {
    constructor() {
      super();

      this.openButton = this.querySelector("[data-drawer-open]");
      this.drawer = this.getDrawer();
      this.wrapper = this.drawer.querySelector("[data-drawer-wrapper]");

      this.openButton.addEventListener("click", this.open.bind(this));

      this.handleClickOutside();

      this.drawer.addEventListener("close", this.close.bind(this));
    }

    connectedCallback() {
      document.querySelector("body").append(this.drawer);

      if (!this.drawer.open) {
        this.unmountDrawerHeadings();
      }
    }

    disconnectedCallback() {
      this.drawer.remove();
    }

    open() {
      this.mountDrawerHeadings();
      this.drawer.showModal();
      this.drawer.setAttribute("active", true);
      scrollLock.enable();
      triggerEvent(this.drawer, "drawerOpen");
    }

    close() {
      this.unmountDrawerHeadings();
      this.drawer.setAttribute("active", false);
      scrollLock.disable();
      triggerEvent(this.drawer, "drawerClose");
    }

    mountDrawerHeadings() {
      this.drawer.querySelectorAll("[data-drawer-heading]").forEach((element) => {
        const tagName = element.dataset.drawerHeading;

        if (!tagName || element.tagName.toLowerCase() === tagName.toLowerCase()) return;

        replaceElementTag(element, tagName);
      });
    }

    unmountDrawerHeadings() {
      this.drawer.querySelectorAll("[data-drawer-heading]").forEach((element) => {
        const tagName = element.dataset.drawerHeading;

        if (!tagName || element.tagName.toLowerCase() !== tagName.toLowerCase()) return;

        replaceElementTag(element, element.dataset.drawerHeadingPlaceholder || "div");
      });
    }

    handleClickOutside() {
      this.drawer.addEventListener("click", () => {
        this.drawer.close();
      });
      this.wrapper.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    }

    getDrawer() {
      return (
        this.querySelector("[data-drawer]") ||
        document.querySelector(this.openButton.dataset.drawerOpen)
      );
    }
  }
);
